// eslint-disable-next-line import-x/no-rename-default
import jQuery from './components/jQuery';
import './components/Bootstrap';
import './components/CookieConsent';
import './components/FullHeightIOS';
import initMobileNav from './components/MobileNav';
import initHeadroom from './components/Headroom';
import initAnchors from './components/Anchors';
import initSwiper from './components/Swiper';
import {
  initPhotoSwipeLightbox,
  initIframeSwipeLightbox,
} from './components/PhotoSwipeLightbox';
// import initCustomHover from './components/CustomHover';
import initFilterPanel from './components/FilterPanel';
import initBootstrapCustom from './components/BootstrapCustom';
import initGoogleMap from './components/gmap';
import initMapZH from './components/maps-zh';
// import initBaiduMap from './components/baidu';
import initLanguageSwitch from './components/LanguageSwitch';
import initCategoryMenu from './components/CategoryMenu';

window.initGoogleMap = initGoogleMap;
window.initMapZH = initMapZH;
// window.initBaiduMap = initBaiduMap;
window.initCategoryMenu = initCategoryMenu;

jQuery(() => {
  initMobileNav();
  initHeadroom();
  initAnchors();
  initSwiper();
  // initNouislider();
  initPhotoSwipeLightbox();
  initIframeSwipeLightbox();
  // initCustomHover();
  initFilterPanel();
  initBootstrapCustom();
  initGoogleMap();
  initLanguageSwitch();
  initCategoryMenu();
});
